app.controller("ExamsIndexController", [
    "$scope", "ExamsService", "$stateParams", "$state", "StaticData", "$http", "$uibModal", "usSpinnerService", "toastr", "$window",
    function ($scope, ExamsService, $stateParams, $state, StaticData, $http, $uibModal, usSpinnerService, toastr, $window) {
        $scope.query = $stateParams.query;
        $scope.itemsPerPage = 25;
        $scope.totalItems = {};
        $scope.supportUrl = null;

        loadPage($stateParams.page, function () {
            $scope.currentPage = $stateParams.page;
        });

        function loadPage(page, cb) {
            cb = cb || function () {
                };
            usSpinnerService.spin("root");
            ExamsService.activationList({
                page: page,
                query: $stateParams.query,
                limit: $scope.itemsPerPage
            }).then(function (data) {
                $scope.subjects = data.docs;
                $scope.totalItems = data.total;
                usSpinnerService.stop("root");
                cb();
            });
        }

        StaticData.getItemsByKey("exam-center-support").then(function (data) {
            $scope.supportUrl = data[0].value;
        });

        $scope.submitQuery = function () {
            $state.go(".", {query: $scope.query});
        };

        $scope.view = function (subjectId) {
            $state.go("admin.exam-grades", {subject: subjectId});
        };

        $scope.manage = function () {
            $state.go("admin.exams-manager-index");
        };

        $scope.goToPage = function (page) {
            $state.go(".", {page: page});
        };

        $scope.changePage = function () {
            $scope.goToPage($scope.currentPage);
        };

        $scope.addURL = function (subject, group, $event) {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }
            $uibModal.open({
                controller: "AddMessageContainer",
                templateUrl: _pb + 'lecturer/add-message-container.html',
                size: "md",
                backdrop: 'static',
                resolve: {
                    params: function () {
                        return {
                            subjectName: 'ბმულის გაწერა',
                            supportUrl: $scope.supportUrl
                        };
                    }
                }
            }).result
                .then(function () {
                    toastr.success('', 'ბმული განახლებულია');
                    setTimeout(function () {
                        $window.location.reload();
                    }, 500);
                }, function () {
                });
        };

        // $scope.subjects = [];
        // var socket = new Socket('/selections');
        //
        // $scope.addSubject = function () {
        //     socket.emit('subject:select', {
        //         subject: Math.random().toString(36).substring(7)
        //     });
        // };
        //
        // socket.on('subject:unselect', function (subject) {
        //     console.log(subject);
        //     $scope.subjects.push(subject);
        // });
    }
]);
